'use client';

import { Flex, Input } from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from 'react';

export default function Search() {
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyUp = (e) => {
    if (e.key !== 'Enter') return;

    const value = e?.target?.value || '';

    if(value.trim() === '') return;

    const sluged = value
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const portalUrl = process.env.NEXT_PUBLIC_APP_URL;
    const targetUrl = `${portalUrl}/pesquisa/${sluged}`;

    window.location.href = targetUrl;
  }

  return (
    <Flex border="1px solid" borderColor="blue.500" borderRadius="3xl" alignItems="center" px="5px" w="100%" maxW="260px">
      <Flex w="30px" h="30px" justifyContent="center" alignItems="center">
        <LuSearch size={isFocused ? "1.6em" : "1.2em"}  color="gray.100" style={{ transition: 'all 0.3s ease' }} />
      </Flex>

      <Input
        placeholder="Pesquisar"
        border="none"
        size="sm"
        variant="unstyled"
        bg="none"
        fontSize="1em"
        color="white"
         _placeholder={{
          color: isFocused ? 'gray.300' : 'white',
          fontStyle: 'italic',
          fontWeight: '300',
          fontSize: isFocused ? "1.1em" : "1em",
          transition: 'all 0.3s ease'
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyUp={handleKeyUp}
        />
  </Flex>
  )
}
